/**
 * 사용자 관련 공용 정의 — 로그인 계정 기준 기본 사용자 결정
 * 모든 페이지의 사용자 Segmented가 이걸 공유.
 */
import { useUserStore } from "src/stores/UserStore";

export interface AppUser {
  id: string;
  label: string;
}

export const USERS: AppUser[] = [
  { id: "qnnp@qnnp.net", label: "봉주" },
  { id: "kusahim@gmail.com", label: "미정" },
];

/** 로그인 계정에 해당하는 사용자 (미등록 계정이면 첫 번째) */
export const useDefaultUser = (): AppUser => {
  const email = useUserStore((s) => s.user?.email);
  return USERS.find((u) => u.id === email) || USERS[0];
};
